import { filter, parse } from '@sky-uk-ott/core-video-sdk-js-external-txml/dist/txml';
export function parseTxmlContent(content) {
    return parse(content);
}
export function filterTxmlContent(nodes, fn) {
    return filter(nodes, fn);
}
export function findNodeWithTagName(parent, tagName) {
    return parent.children.find(function(node) {
        return node.tagName === tagName;
    });
}
export function getAttributeFromNode(node, attribute) {
    return node.attributes[attribute];
}

//# sourceMappingURL=txml-utils.js.map